export const ceilOrFloor = (num: number) => {
  const precisionScore = num.toPrecision(4); // convert so we can properly ceil or floor the score
  const firstScoreDigit = parseInt(precisionScore.toString().split('.')[1][0]);
  const modifiedNum = firstScoreDigit >= 5 ? Math.ceil(num) : Math.floor(num);
  return modifiedNum;
};
